import { useEffect, useState } from "react";
import { api } from "../utils/api";
import { renderNewsHtml, isRichTextEmpty } from "../utils/sanitize";

/**
 * Übergangs-Bereich zwischen Hero und Kontakt-Bar.
 * Zeigt IMMER den blauen Verlauf (Hero-Ende).
 * Wenn aktive News-Items vorhanden sind, erscheint für jeden ein goldener Rahmen.
 */
export default function NewsBanner() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api.getPublicNews()
      .then(({ data }) => {
        if (cancelled || !data || !data.ok) return;
        setItems(Array.isArray(data.items) ? data.items : []);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const visible = items.filter((it) => {
    const subj = (it.subject || "").trim();
    return subj !== "" || !isRichTextEmpty(it.body);
  });
  const hasNews = visible.length > 0;

  return (
    <div
      className="news-banner"
      data-testid="news-banner"
      role={hasNews ? "region" : undefined}
      aria-label={hasNews ? "Aktuelle Praxis-Info" : undefined}
    >
      {visible.map((it) => {
        const align = ["left", "center", "right"].includes(it.subject_align)
          ? it.subject_align : "left";
        const subject = (it.subject || "").trim();
        const bodyEmpty = isRichTextEmpty(it.body);
        return (
          <div key={it.id} className="news-banner-inner" data-testid={`news-banner-item-${it.id}`}>
            {subject && (
              <h2
                className="news-banner-subject"
                data-testid="news-banner-subject"
                style={{ textAlign: align }}
              >
                {subject}
              </h2>
            )}
            {!bodyEmpty && (
              <div
                className="news-banner-body"
                data-testid="news-banner-body"
                dangerouslySetInnerHTML={{ __html: renderNewsHtml(it.body) }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
